import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    tone?: 'race' | 'light'
    centered?: boolean
    className?: string
}

const Eyebrow: FC<EyebrowProps> = ({ children, tone = 'race', centered = false, className }): ReactNode => {
    return (
        <p
            className={cn(
                'flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.24em]',
                tone === 'race' ? 'text-race-bright' : 'text-white/85',
                centered && 'justify-center',
                className
            )}
        >
            <span aria-hidden='true' className={cn('h-px w-8 shrink-0', tone === 'race' ? 'bg-race' : 'bg-white/60')} />
            {children}
        </p>
    )
}

export default Eyebrow
